import coursehero from "../../assets/Hero Background.svg";

const CourseHeroSection = () => {
  // Google Form URL
  // const enrollmentFormUrl =
  //   "https://docs.google.com/forms/d/15M_6n3icacumZTb2_xTMTnhZN-lNgGborhIDkUukFKk";

  // // Handle enrollment button click
  // const handleEnrollClick = () => {
  //   // Open the Google Form in a new tab
  //   window.open(enrollmentFormUrl, "_blank");
  // };

  return (
    <div>
      <div className="relative w-full h-[600px] md:h-[700px] lg:h-[600px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={coursehero}
            alt="Course hero background"
            fill
            className="object-cover  w-full h-full"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>

        <div className="relative z-20 container mx-auto lg:px-16 px-8 py-20 h-full flex flex-col justify-center">
          <h4 className="text-white text-xl font-bold mb-4">CEPHAS ICT HUB</h4>

          <h1 className="text-white text-5xl font-bold leading-tight mb-4 font-Outfit">
            Training, Building and
            <br />
            Promoting
          </h1>

          <p className="text-white text-xl mb-8 font-Outfit">
            for Community Development and Global Excellence
          </p>

          {/* <div>
            <button
              onClick={handleEnrollClick}
              className="px-8 py-3 bg-[#1e4b94] text-white rounded-md font-medium font-Outfit"
            >
              Enroll Now
            </button>
          </div> */}
        </div>
      </div>
      {/* 
      <div className="flex flex-col md:flex-row w-full max-w-7xl mx-auto lg:px-20 px-8 pt-20 pb-12 gap-8">
        <div className="w-full md:w-1/2 space-y-6">
          <h2 className="text-3xl font-bold text-[#1a365d] font-Outfit">
            OCTOBER TECH
          </h2>
          <h1 className="text-6xl font-bold text-[#ff5757] font-Outfit">
            INVEST IN YOUR FUTURE TODAY!
          </h1>
          <h3 className="text-2xl font-bold text-[rgb(26,54,93)] leading-tight font-Outfit">
            A great time to explore our courses and start learning
          </h3>

          <div className="mt-10">
            <h4 className="text-2xl font-medium text-[#1a365d] font-Outfit">
              Big Dreams. Small Budget.
            </h4>

            <p className="text-lg text-[#1a365d] mt-4 font-Outfit">
             
              Explore all courses now
            </p>

            <p className="text-xl font-medium text-[#ff5757] mt-8 font-Outfit">
              Offer ends 23rd of November
            </p> 

            <button
              onClick={handleEnrollClick}
              className="mt-8 px-8 py-3 bg-gradient-to-r font-Outfit from-[#ff5757] to-[#d63939] text-white rounded-md font-medium"
            >
              Enroll Now
            </button>
          </div>
        </div>

        <div className="w-full md:w-1/2">
          <h3 className="text-2xl font-bold text-[#1a365d] font-Outfit mb-6">
            Courses Include:
          </h3>

          <div className="space-y-4">
            {[
              "Software Engineering",
              "UI/UX",
              "Data Science & AI",
              "Automation: (Robotics/IOT)",
              "Cyber Security",
              "Digital Marketing",
            ].map((course, index) => (
              <div
                key={index}
                className="bg-gray-50 px-6 py-2 rounded-md shadow-sm"
              >
                <p className="text-lg text-[#1a365d]">{course}</p>
              </div>
            ))}

            <button
              onClick={handleEnrollClick}
              className="w-full mt-4 px-8 font-Outfit py-4 bg-[#4B5563] text-white rounded-md font-medium"
            >
              Enroll Now
            </button>
            <p className=" font-Outfit text-[#4B5563] text-sm lg:pl-32">
              Click "Enroll Now" to fill out the registration form
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default CourseHeroSection;
